import { render } from "./script-preview-card.vue?vue&type=template&id=5ff4ffd0"
import script from "./script-preview-card.vue?vue&type=script&lang=js"
export * from "./script-preview-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__